import cx from "classnames";
import { forwardRef, ReactNode } from "react";
import { useShallow } from "zustand/react/shallow";

import Box from "ds/components/Box";

import styles from "./styles.module.css";
import useFloatingDrag from "../useFloatingDrag";
import useAssistantPanelStore from "../useStore";
import useIsAssistantPageMode from "../../hooks/useIsAssistantPageMode";

type AssistantPanelLayoutHeaderProps = {
  children: ReactNode;
};

const AssistantPanelLayoutHeader = forwardRef<HTMLDivElement, AssistantPanelLayoutHeaderProps>(
  function AssistantPanelLayoutHeader({ children }, ref) {
    const isAssistantPageMode = useIsAssistantPageMode();
    const { variant, toggleFullscreen } = useAssistantPanelStore(
      useShallow((state) => ({
        variant: state.variant,
        toggleFullscreen: state.toggleFullscreen,
      }))
    );

    const { onDragStart } = useFloatingDrag();

    const isFloatingPanel =
      !isAssistantPageMode && (variant === "floating" || variant === "fullscreen");
    const isDraggable = isFloatingPanel && variant === "floating";

    return (
      <Box
        ref={ref}
        padding="x-large"
        gap="medium"
        justify="between"
        align="center"
        onPointerDown={isDraggable ? onDragStart : undefined}
        onDoubleClick={isFloatingPanel ? toggleFullscreen : undefined}
        className={cx(styles.header, {
          [styles.floating]: isFloatingPanel,
          [styles.draggable]: isDraggable,
        })}
      >
        {children}
      </Box>
    );
  }
);

export default AssistantPanelLayoutHeader;
